const initialState = {
  loading: false,
  userLoading: false,
  error: null,
};

export default function purchasesListReducer(state = initialState, action) {
  switch (action.type) {
    case "USER_PURCHASES_FETCH_REQUESTED":
      return { ...state, userLoading: true, error: null };
    case "USER_PURCHASES_FETCHED":
      return {
        ...state,
        userLoading: false,
        userPurchases: {
          ids: action.payload.result,
          pagination: action.payload.pagination,
        },
      };
    case "USER_PURCHASES_ERROR":
      return { ...state, userLoading: false, error: action.payload };
    case "PRODUCT_PURCHASES_FETCH_REQUESTED":
      return {
        ...state,
        loading: true,
        error: null,
      };
    case "PRODUCT_PURCHASES_FETCHED":
      return {
        ...state,
        loading: false,
        [action.payload.productId]: {
          ids: action.payload.result,
          pagination: action.payload.pagination,
        },
      };
    case "PRODUCT_PURCHASES_ERROR":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
}
